let routes = [
    {
		// 家人数据
		path: '/FamilyList',
		name: 'FamilyList',
		component: () => import('@/views/Family/FamilyList/FamilyList'),
		meta: {
			title: '家人数据',
			keepAlive: true
		}
	},
	{
		// 添加家人
		path: '/AddBinding',
		name: 'AddBinding',
		component: () => import('@/views/Family/AddBinding/Binding'),
		meta: {
			title: '添加家人',
			keepAlive: true
		}
    },
    {
		// 身份验证
		path: '/Authentication',
		name: 'Authentication',
		component: () => import('@/views/Family/Authentication/Authentication'),
		meta: {
			title: '身份验证',
			keepAlive: true
		}
	},

];

export default routes;


// WEBPACK FOOTER //
// ./src/router/routerPage/Family.js